import React, { useRef } from 'react'
import FilterOptionsOptionDropdown from '../Dropdown/FilterOptionsOptionDropdown'

const FilterOptions = ({
  filterOption,
  filterOptionChangeHandler,
  showFilterOptionDropdownHandler,
  showSelectedFilterOptionNature,
  showSelectedFilterOptionValues,
  setShowSelectedFilterOptionNature,
  setShowSelectedFilterOptionValues,
  removeFilterOptionHandler,
  nature,
  priority,
  duedate,
  assignees,
  index,
}) => {
  const natureButtonRef = useRef(null)
  const valueButtonRef = useRef(null)
  return (
    <li className='selected-filter'>
      <span className='selected-label'>{filterOption.filter}</span>
      <div className='filter'>
        <button
          ref={natureButtonRef}
          className='filter-button'
          onClick={() => showFilterOptionDropdownHandler(true, index)}
        >
          {filterOption.nature ? 'Is' : 'Is not'}
        </button>
        {showSelectedFilterOptionNature === index && (
          <FilterOptionsOptionDropdown
            data={[
              {
                value: true,
                label: 'Is',
              },
              {
                value: false,
                label: 'Is not',
              },
            ]}
            ref={natureButtonRef}
            isNature={true}
            index={index}
            isMultiple={false}
            activeFilters={filterOption.nature}
            onChange={filterOptionChangeHandler}
            close={setShowSelectedFilterOptionNature}
          />
        )}
      </div>
      <div className='filter'>
        <button
          className='filter-button value'
          ref={valueButtonRef}
          onClick={() => showFilterOptionDropdownHandler(false, index)}
        >
          {filterOption.filter === 'Assignee'
            ? filterOption.value.length > 1
              ? `${filterOption.value.length} Assignee`
              : filterOption.value[0]
            : filterOption.filter === 'Priority'
              ? filterOption.value.map((item) => item.split('_')[1]).join(' or ')
              : filterOption.value.join(' or ')}
        </button>
        {showSelectedFilterOptionValues === index && (
          <FilterOptionsOptionDropdown
            data={
              filterOption.filter === 'Assignee'
                ? assignees
                : filterOption.filter === 'Due Date'
                  ? duedate
                  : filterOption.filter === 'Priority'
                    ? priority
                    : filterOption.filter === 'Nature'
                      ? nature
                      : []
            }
            ref={valueButtonRef}
            isNature={false}
            index={index}
            isMultiple={true}
            activeFilters={filterOption.value}
            close={setShowSelectedFilterOptionValues}
            onChange={filterOptionChangeHandler}
          />
        )}
      </div>
      <button
        onClick={() => removeFilterOptionHandler(index)}
        className='remove-filter-button'
      >
        x
      </button>
    </li>
  )
}

export default FilterOptions
